import { Logo } from '../../view/logo/logo';

import style from './user-role-page.module.css';

const EN = {
    consumer: 'Consumer',
    partner: 'JORI partner',
    partnerDesc: 'If you want to receive your own login-details and more information about JORI, do no hesitate to send an email to sales@jori.com'
};

type LoginMessages = typeof EN;

const MESSAGES: Record<string,LoginMessages> = {
    en: EN,
    fr: {
        consumer: 'Consommateur',
        partner: 'JORI Partner',
        partnerDesc: "Si vous souhaitez recevoir votre propre login et plus d'informations sur JORI, n'h'ésitez pas à envoyer un email à sales@jori.com"
    },
    nl: {
        consumer: 'Consument',
        partner: 'JORI Partner',
        partnerDesc: 'Ais u uw eigen login-gegevens en meer informatie over JORI wenst te ontvangen, aarzel dan niet om een email te sturen naar sales@jori.com'
    },
    de: {
        consumer: 'Konsument',
        partner: 'JORI Partner',
        partnerDesc: 'Wenn Sie Ihren eigenen Login-Details und weitere Informationen über JORI erhalten möchten, senden sie eine Email an sales@jori.com'
    }
}

export function UserRolePage({ lang, disabled, onConsumer, onPartner } : {
    lang: string
    disabled: boolean
    onConsumer: () => void
    onPartner: () => void
}) {

    const messages = MESSAGES[lang];

    return <div role="presentation" className={style.container}>
        <Logo className={style.logo}/>
        <div role="presentation" className={style.choiceArea}>
            <button className={style.consumer} type="button" onClick={onConsumer} disabled={disabled}>{messages.consumer}</button>
            <button className={style.partner} type="button" onClick={onPartner} disabled={disabled}>{messages.partner}</button>
            <p className={style.partnerDesc}>{messages.partnerDesc}</p>
        </div>
    </div>

}